import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import theme from '../../theme';

const FacebookWhite = (props: SvgIconProps) => {
  const [isHover, setIsHover] = React.useState(false);
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...props}
    >
      <path
        d="M16 3C12.6388 3.00006 9.40826 4.30196 6.98625 6.63252C4.56424 8.96308 3.13902 12.1411 3.00965 15.4999C2.88028 18.8586 4.05681 22.1368 6.29238 24.6468C8.52794 27.1568 11.6488 28.7033 15 28.9619V19.0001H12C11.7348 19.0001 11.4804 18.8948 11.2929 18.7072C11.1054 18.5197 11 18.2653 11 18.0001C11 17.7349 11.1054 17.4805 11.2929 17.293C11.4804 17.1055 11.7348 17.0001 12 17.0001H15V14.0001C15.0012 12.9396 15.423 11.9229 16.1729 11.173C16.9228 10.4231 17.9395 10.0013 19 10.0001H21C21.2652 10.0001 21.5196 10.1055 21.7071 10.293C21.8946 10.4805 22 10.7349 22 11.0001C22 11.2653 21.8946 11.5197 21.7071 11.7072C21.5196 11.8948 21.2652 12.0001 21 12.0001H19C18.4698 12.0007 17.9614 12.2116 17.5865 12.5866C17.2115 12.9615 17.0006 13.4699 17 14.0001V17.0001H20C20.2652 17.0001 20.5196 17.1055 20.7071 17.293C20.8946 17.4805 21 17.7349 21 18.0001C21 18.2653 20.8946 18.5197 20.7071 18.7072C20.5196 18.8948 20.2652 19.0001 20 19.0001H17V28.9619C20.3512 28.7033 23.472 27.1567 25.7076 24.6468C27.9431 22.1368 29.1197 18.8586 28.9903 15.4999C28.8609 12.1412 27.4357 8.9631 25.0137 6.63254C22.5917 4.30198 19.3612 3.00007 16 3Z"
        fill={isHover ? theme.palette.cyan : theme.palette.greyscale.white}
      />
    </SvgIcon>
  );
};

export default FacebookWhite;
